<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<app-vehicles
    *ngIf="currentAppliant"
    [applicantId]="currentAppliant"
    (clickNewException)="goToNewException($event)"
    (clickNewVehicle)="goToNewVehicle()"
></app-vehicles>